import React from 'react';
import { CheckCircle, Calendar } from 'lucide-react';

interface ConsultationSuccessProps {
  consultationData: {
    name: string;
    preferredDate: string;
    preferredTime: string;
  };
}

export default function ConsultationSuccess({ consultationData }: ConsultationSuccessProps) {
  const date = new Date(consultationData.preferredDate).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="text-center py-8">
      <div className="flex justify-center mb-6">
        <CheckCircle className="w-16 h-16 text-green-500" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        Consultation Scheduled!
      </h3>
      <p className="text-gray-600 dark:text-gray-300 mb-6">
        Thank you {consultationData.name}! We've received your consultation request.
      </p>
      <div className="bg-purple-50 dark:bg-purple-900/20 p-6 rounded-lg inline-block">
        <div className="flex items-center justify-center mb-2">
          <Calendar className="w-5 h-5 text-purple-600 mr-2" />
          <span className="text-purple-600 font-medium">Your Preferred Time</span>
        </div>
        <p className="text-gray-700 dark:text-gray-300">
          {date} at {consultationData.preferredTime}
        </p>
      </div>
      <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
        We'll send you a confirmation email with meeting details and next steps.
      </p>
    </div>
  );
}